import React, {useContext, useEffect} from "react"
import {Navigate} from "react-router-dom"
import {
    WorkflowContext,
    WORKFLOW_EXIT_PATH,
} from "../../../src/context/WorkflowContextProvider"

const WorkflowStart = ({workflowId, basePath}) => {
    const {ensureWorkflow, getWorkflowById, isWorkflowLoaded} =
        useContext(WorkflowContext)

    useEffect(() => ensureWorkflow(workflowId), [workflowId])

    if (!isWorkflowLoaded(workflowId)) return null

    const startStepId = getWorkflowById(workflowId)?.startStepId

    if (!startStepId) {
        console.warn(
            `[Workflow] Workflow "${workflowId}" oder dessen startStepId nicht gefunden.`,
        )
        return (
            <Navigate
                to={WORKFLOW_EXIT_PATH}
                replace
            />
        )
    }

    return (
        <Navigate
            to={`${basePath}/${startStepId}`}
            replace
        />
    )
}

export default WorkflowStart
